import React from 'react';
import { useIntl, defineMessages } from 'react-intl-next';
import { styled } from '@compiled/react';

import { xcss, Box } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { ObjectCommentPageReactions } from './ObjectCommentPageReactions';

const commentHeaderContainerStyles = xcss({
	borderTop: `1px solid ${token('color.border')}`,
	background: 'color.text.inverse',
	height: '64px',
	width: '100%',
	display: 'flex',
	padding: 'space.200',
	justifyContent: 'space-between',
	alignItems: 'center',
	alignSelf: 'stretch',
});

const commentHeaderReactionsContainerStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-end',
	alignSelf: 'stretch',
});

const i18n = defineMessages({
	objectCommentHeaderText: {
		id: 'object-comments.object-comment-header.text',
		defaultMessage: 'Comments',
		description: 'Label for the object comments header',
	},
});

// The Text component currently can't handle this use case because it doesn't support a large enough font
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HeaderText = styled.span({
	color: token('color.text.subtle'),
	font: token('font.heading.medium'),
	fontFamily: token('font.family.heading'),
	fontWeight: token('font.weight.medium'),
});

export const ObjectCommentHeader = ({ isOffline = false }: { isOffline?: boolean }) => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={commentHeaderContainerStyles}>
			<HeaderText>{formatMessage(i18n.objectCommentHeaderText)}</HeaderText>

			<Box xcss={commentHeaderReactionsContainerStyles}>
				<ObjectCommentPageReactions isOffline={isOffline} />
			</Box>
		</Box>
	);
};
